import type {DIContainerFactory} from '../../../../IoC/containerFactories/types';

import {ContainerBinder} from '../../../../IoC/ContainerBinder';
import {
  trackersBindDomain,
  trackersBindStores,
  trackersBindUseCases,
} from './bind/trackersBind.common';
import {trackersBindPortsJrpc} from './bind/trackersBind.port.jrpc';

export const trackersContainerFactoryJrpc: DIContainerFactory = ({
  containerToBind = ContainerBinder.createContainer(),
} = {}) => {
  trackersBindDomain(containerToBind);
  trackersBindUseCases(containerToBind);
  trackersBindStores(containerToBind);
  trackersBindPortsJrpc(containerToBind);

  return containerToBind;
};
